import {
  UltimateForms,
} from '../common/Ultimateform';

require('jqmask');


const localZipMask = {
  france: '99999',
  belgique: '9999',
  luxembourg: 'L-9999',
  netherlands: '9999 aa',
};
const localZipValidator = {
  france(value) { return value !== '' && (value <= 95999 || value === 98000); },
  belgique() { return true; },
  luxembourg() { return true; },
  netherlands(value) { return (/^\d{4}[ ][a-zA-Z]{2}$/).test(value); },
};

$.validator.addMethod(
  'zipValidation',
  (value, element) => {
    if ($(element).hasClass('required') === false) {
      return true;
    }

    if (value === undefined || value === null || value === '') {
      return false;
    }

    let validator = localZipValidator.france;

    const form = UltimateForms().get($(element).attr('data-form'));
    if (form !== undefined && form !== null && OCMS.GlobalVars.Brand === 'cdm' && (form.id === 'shipping' || form.id === 'billing')) {
      const country = form.country().toLowerCase();
      validator = localZipValidator[country];
    }

    return validator.call(this, value);
  }
);

$(() => {
  $("[data-id='mobile']").mask('99 99 99 99 99', { placeholder: '' });
  if (OCMS.GlobalVars.Brand !== 'cdm') { $("[data-id='zip']").mask('99999', { placeholder: '' }); }

  $(".updateValidation[data-id='country']").change(() => {
    const $el = $(this);
    const country = $el.val().toLowerCase();
    if (country === 'france') {
      $(`[data-id='${$el.attr('data-form')}']`).find("[data-id='zip']").mask('99999', { placeholder: '' });
    } else if (country === 'belgique') {
      $(`[data-id='${$el.attr('form')}']`).find("[data-id='zip']").mask('9999', { placeholder: '' });
    }
  });
});

$(document).on('initialized.ocms.ultimate-form', (event, form) => {
  if (OCMS.GlobalVars.Brand === 'cdm' && form !== undefined && form !== null) {
    if (form.id === 'shipping') {
      const FranceSpecificConfigureShippingMethod = () => {
        const list = $("[data-id='shippingMethodList']");
        const country = form.country().toLowerCase();
        $('.rdblistShippingMethodStep3').show();
        $('.rdblistShippingMethodStep3 input:radio').attr('checked', '');
        $('.rdblistShippingMethodStep3 input:radio').prop('checked', false);

        const shippsToHide = $('.rdblistShippingMethodStep3').filter(() => $(this).attr('data-title').toLowerCase().indexOf(country) === -1);
        list.find('.rdblistShippingMethodStep3 input:radio').trigger('change');

        shippsToHide.hide();
        OCMSBagStep3.EqualizeShippingMethods();
      };

      FranceSpecificConfigureShippingMethod();
      form.countryField.on('change', FranceSpecificConfigureShippingMethod);
    }

    if (form.id === 'shipping' || form.id === 'billing') {
      const FranceSpecificConfigureZip = () => {
        const country = form.country().toLowerCase();
        form.zipField.mask(localZipMask[country]);
      };

      if (form.id === 'shipping') {
        FranceSpecificConfigureZip();
        form.countryField.on('change', FranceSpecificConfigureZip);
      }
    }
  }
});



// WEBPACK FOOTER //
// ./js/countryForm/france.form.js